export default [
  {
    id: "developpeurFrontEnd-langageDeProgrammation",
    source: "developpeurFrontEnd",
    target: "langageDeProgrammation",
  },
  {
    id: "developpeurFrontEnd-bibliothequesFrameWorkJS",
    source: "developpeurFrontEnd",
    target: "bibliothequesFrameWorkJS",
  },
  {
    id: "developpeurFrontEnd-librariesUi",
    source: "developpeurFrontEnd",
    target: "librariesUi",
  },
  {
    id: "developpeurFrontEnd-pratiquesFrontEnd",
    source: "developpeurFrontEnd",
    target: "pratiquesFrontEnd",
  },
  {
    id: "langageDeProgrammation-javaScript",
    source: "langageDeProgrammation",
    target: "javaScript",
    label: "Page web dynamique",
  },
  {
    id: "javaScript-typeScript",
    source: "javaScript",
    target: "typeScript",
    label: "Typage statique",
  },
  {
    id: "javaScript-bibliothequesFrameWorkJS",
    source: "javaScript",
    target: "bibliothequesFrameWorkJS",
    label: "Accelerer les developpements",
  },
  {
    id: "langageDeProgrammation-html",
    source: "langageDeProgrammation",
    target: "html",
    label: "Structure de page web",
  },
  {
    id: "langageDeProgrammation-html",
    source: "langageDeProgrammation",
    target: "css",
    label: "Style/mise en forme",
  },
  { id: "css-scss", source: "css", target: "scss" },
  { id: "css-sass", source: "css", target: "sass" },
  { id: "css-less", source: "css", target: "less" },
  {
    id: "bibliothequesFrameWorkJS-react",
    source: "bibliothequesFrameWorkJS",
    target: "react",
    label: "Flexibilité | petits & moyens projets",
  },
  {
    id: "developpeurFrontEnd-LibrariesDeTests",
    source: "developpeurFrontEnd",
    target: "LibrariesDeTests",
    label: "",
  },
  {
    id: "bibliothequesFrameWorkJS-angular",
    source: "bibliothequesFrameWorkJS",
    target: "angular",
    label: "Structuré | gros proj",
  },
  {
    id: "bibliothequesFrameWorkJS-vue",
    source: "bibliothequesFrameWorkJS",
    target: "vue",
    label: "Simplicité | petits & moyens proj",
  },
  {
    id: "bibliothequesFrameWorkJS-svelte",
    source: "bibliothequesFrameWorkJS",
    target: "svelte",
    label: "Performance | projets mixtes",
  },
  {
    id: "react-reactjs",
    source: "react",
    target: "reactjs",
    label: "Librairie Web",
  },
  {
    id: "react-reactNative",
    source: "react",
    target: "reactNative",
    label: "Mobile",
  },
  {
    id: "react-next",
    source: "react",
    target: "next",
    label: "Framework",
  },
  {
    id: "react-gatsby",
    source: "react",
    target: "gatsby",
    label: "Framework",
  },
  {
    id: "css-librariesCSS",
    source: "css",
    target: "librariesCSS",
    label: "Librairies CSS populaires",
  },
  {
    id: "librariesCSS-tailwind",
    source: "librariesCSS",
    target: "tailwind",
    label: "",
  },
  {
    id: "librariesCSS-materialize",
    source: "librariesCSS",
    target: "materialize",
    label: "",
  },
  {
    id: "librariesCSS-bulma",
    source: "librariesCSS",
    target: "bulma",
    label: "",
  },
  {
    id: "librariesCSS-bootstrap",
    source: "librariesCSS",
    target: "bootstrap",
    label: "",
  },
  {
    id: "angular-angularCli",
    source: "angular",
    target: "angularCli",
    label: "",
  },
  {
    id: "angular-angularMaterial",
    source: "angular",
    target: "angularMaterial",
    label: "",
  },
  {
    id: "vue-vueCli",
    source: "vue",
    target: "vueCli",
    label: "",
  },
  {
    id: "vue-vueNative",
    source: "vue",
    target: "vueNative",
    label: "Mobile",
  },
  {
    id: "svelte-svelteKit",
    source: "svelte",
    target: "svelteKit",
    label: "Web",
  },
  {
    id: "svelte-svelteNative",
    source: "svelte",
    target: "svelteNative",
    label: "Mobile",
  },
  {
    id: "svelte-svelteElectron",
    source: "svelte",
    target: "svelteElectron",
    label: "Desktop",
  },
  {
    id: "LibrariesDeTests-cypress",
    source: "LibrariesDeTests",
    target: "cypress",
    label: "Test end 2 end",
  },
  {
    id: "LibrariesDeTests-jasmine",
    source: "LibrariesDeTests",
    target: "jasmine",
    label: "",
  },
  {
    id: "LibrariesDeTests-enzyme",
    source: "LibrariesDeTests",
    target: "enzyme",
    label: "",
  },
  {
    id: "LibrariesDeTests-jest",
    source: "LibrariesDeTests",
    target: "jest",
    label: "",
  },
  {
    id: "LibrariesDeTests-testingLibrary",
    source: "LibrariesDeTests",
    target: "testingLibrary",
    label: "",
  },
  {
    id: "librariesUi-semanticUi",
    source: "librariesUi",
    target: "semanticUi",
    label: "",
  },
  {
    id: "librariesUi-foundation",
    source: "librariesUi",
    target: "foundation",
    label: "",
  },
  {
    id: "librariesUi-semchakraUianticUi",
    source: "librariesUi",
    target: "chakraUi",
    label: "",
  },
  {
    id: "librariesUi-antDesign",
    source: "librariesUi",
    target: "antDesign",
    label: "",
  },
  {
    id: "librariesUi-daisyUi",
    source: "librariesUi",
    target: "daisyUi",
    label: "",
  },
  {
    id: "librariesUi-materialUi",
    source: "librariesUi",
    target: "materialUi",
    label: "",
  },
  {
    id: "pratiquesFrontEnd-responsiveDesign",
    source: "pratiquesFrontEnd",
    target: "responsiveDesign",
    label: "",
  },
  {
    id: "pratiquesFrontEnd-tdd",
    source: "pratiquesFrontEnd",
    target: "tdd",
    label: "Test Driven Development",
  },
  {
    id: "pratiquesFrontEnd-bdd",
    source: "pratiquesFrontEnd",
    target: "bdd",
    label: "Behaviour Driven Development",
  },
  {
    id: "pratiquesFrontEnd-ddd",
    source: "pratiquesFrontEnd",
    target: "ddd",
    label: "Domain Driven Development",
  },
  {
    id: "pratiquesFrontEnd-atomiqueDesign",
    source: "pratiquesFrontEnd",
    target: "atomiqueDesign",
    label: "",
  },
  {
    id: "pratiquesFrontEnd-principeSolid",
    source: "pratiquesFrontEnd",
    target: "principeSolid",
    label: "",
  },
  {
    id: "pratiquesFrontEnd-cleanArchitecture",
    source: "pratiquesFrontEnd",
    target: "cleanArchitecture",
    label: "",
  },
  {
    id: "pratiquesFrontEnd-testsUnitairecodeReview",
    source: "pratiquesFrontEnd",
    target: "testsUnitairecodeReview",
    label: "",
  },
  {
    id: "pratiquesFrontEnd-codeReview",
    source: "pratiquesFrontEnd",
    target: "codeReview",
    label: "",
  },
  {
    id: "pratiquesFrontEnd-ergonomie",
    source: "pratiquesFrontEnd",
    target: "ergonomie",
    label: "",
  },
  {
    id: "pratiquesFrontEnd-testsUnitaire",
    source: "pratiquesFrontEnd",
    target: "testsUnitaire",
    label: "",
  },
  {
    id: "developpeurFrontEnd-uxtools",
    source: "developpeurFrontEnd",
    target: "uxtools",
    label: "",
  },
  {
    id: "uxtools-figma",
    source: "uxtools",
    target: "figma",
    label: "",
  },
  {
    id: "uxtools-sketch",
    source: "uxtools",
    target: "sketch",
    label: "",
  },
  {
    id: "uxtools-AdobeXD",
    source: "uxtools",
    target: "AdobeXD",
    label: "",
  },
  {
    id: "uxtools-inVisionStudio",
    source: "uxtools",
    target: "inVisionStudio",
    label: "",
  },
  {
    id: "uxtools-marvel",
    source: "uxtools",
    target: "marvel",
    label: "",
  },
  {
    id: "developpeurFrontEnd-versioning",
    source: "developpeurFrontEnd",
    target: "versioning",
    label: "",
  },
  {
    id: "versioning-git",
    source: "versioning",
    target: "git",
    label: "",
  },
  {
    id: "versioning-gitflow",
    source: "versioning",
    target: "gitflow",
    label: "",
  },
  {
    id: "versioning-gitlab",
    source: "versioning",
    target: "gitlab",
    label: "",
  },
   { id: "a2-rect", source: "a2", target: "rect", label: "Vers rect" },
  { id: "tailwind-rect", source: "1", target: "3", label: "Engendre" },
];
